<template>
  <div class="tabbaritem">
    <div class="tab-bar-item" @click="itemClick">
      <div v-if="!isActive">
        <slot name="img-icon"></slot>
      </div>
      <div v-else>
      <slot name="img-icon-active"></slot>
      </div>
      <div :class="{active:isActive}">
        <slot name="text-icon"></slot>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "TabBarItem",
        props:{
          path:String
        },
        data(){
            return{

            }
        },
        computed:{
            isActive(){
                return this.$route.path.indexOf(this.path) !== -1
            }
        },
        methods:{
            itemClick(){
                this.$router.push(this.path)
            }
        }
    }
</script>

<style scoped>
  .tabbaritem{
    flex: 1;
    text-align: center;
    height: 49px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tab-bar-item {
    text-align: center;
    border-right: 2px solid #eeeeee;
    font-size: 12px;
    line-height: 1.11em;
  }
  .tabbaritem .tab-bar-item:last-of-type{
    border-right: none;
  }

  .tab-bar-item img {
    width: 24px;
    height: 24px;
  }
  .active{
    color: #409eff;
  }
</style>
